export const checkPasswordComplexity = (
  password: string | undefined
): boolean => {
  if (password) {
    if (password.length < 8) return false;
    let typeCount = 0;

    if (/[0-9]/.test(password)) typeCount++;
    if (/[a-zA-Z]/.test(password)) typeCount++;
    if (/[^A-Za-z0-9]/.test(password)) typeCount++;

    return typeCount >= 2;
  }
  return false;
};
